<template>
  <div>
    <div class="first"></div>
    <div class="x-desc" style="display: none">
      <div class="titleSub">Introduction to Plan X</div>
      <div class="title wow animate__animated durationTime animate__fadeInUp">X计划简介</div>
      <div class="slogan">
        <div class="one wow animate__animated durationTime animate__fadeInUp">
          一次投入，一年回本，五年投资回报率
        </div>
        <div class="two wow animate__animated durationTime animate__fadeInUp" style="display: flex">
          <count-to
            separator=""
            :startVal="0"
            :endVal="400"
            :duration="1000"
            ref="count4"
          ></count-to
          ><div>%</div>
        </div>
      </div>
      <div class="desc-one wow animate__animated durationTime animate__fadeInUp">
        X计划是柠檬网联值十周年之际为了回馈合作伙伴的支持，推出开放赋能、全新升级的项目合作模式。
      </div>
      <div class="desc-two wow animate__animated durationTime animate__fadeInUp">
        由行业资深团队耗时10年精心打造，适配职教校园无线网络的硬件、系统、平台一体化解决方案，勘、设、建、
        运、维、服全过程托管扶持，让您省时省力省心放心，邀您合作共享职教市场亿万蓝海。
      </div>
    </div>
    <div class="x-about">
      <div style="position: absolute;top:50%;left: 50%; transform: translate(-50%, -50%);background: #4E0305;border-radius: 50%">
        <img src="../../assets/image/xplan/x-about-icon.png" style="width: 0.92rem;">
      </div>

      <div  class="left">
        <div class="titleSub">About the “X Plan”</div>
        <div class="title wow animate__animated durationTime animate__fadeInUp">X计划简介</div>
        <div class="desc wow animate__animated durationTime animate__fadeInUp">
          柠檬网联过去10年专注工厂和校园场景打造的无线网络<span class="main-color">（软件、硬件、平台）</span>一体化解决方案和
          <div style="display: inline-block;margin-top: -0.1rem;position: relative;width: 0.36rem;height: 0.38rem;
}">
            <img src="../../assets/image/xplan/x-about-icon1.png" style="width: 0.36rem;position: absolute;top: 0.1rem;">
          </div>
          <div style="display: inline-block;margin-top: -0.1rem;position: relative;width: 0.36rem;height: 0.38rem;
}">
            <img src="../../assets/image/xplan/x-about-icon2.png" style="width: 0.36rem;position: absolute;top: 0.1rem;">
          </div>
          <div style="display: inline-block;margin-top: -0.1rem;position: relative;width: 0.36rem;height: 0.38rem;
}">
            <img src="../../assets/image/xplan/x-about-icon3.png" style="width: 0.36rem;position: absolute;top: 0.1rem;">
          </div>
          <div style="display: inline-block;margin-top: -0.1rem;position: relative;width: 0.36rem;height: 0.38rem;
}">
            <img src="../../assets/image/xplan/x-about-icon4.png" style="width: 0.36rem;position: absolute;top: 0.1rem;">
          </div>
          <div style="display: inline-block;margin-top: -0.1rem;position: relative;width: 0.36rem;height: 0.38rem;
}">
            <img src="../../assets/image/xplan/x-about-icon5.png" style="width: 0.36rem;position: absolute;top: 0.1rem;">
          </div>
          <div style="display: inline-block;margin-top: -0.1rem;position: relative;width: 0.36rem;height: 0.38rem;
}">
            <img src="../../assets/image/xplan/x-about-icon6.png" style="width: 0.36rem;position: absolute;top: 0.1rem;">
          </div>

          一站式服务体系，迄今为止已为超 2000 家工厂、企业、校园解决了无线网络建设和运营需求，并通过无线网络解决方案助力合伙伙伴持续产生收益。
        </div>
      </div >
      <div class="right">
        <div class="desc wow animate__animated durationTime animate__fadeInUp">
          针对职教校园网络市场缺少资金预算支持，亟需高性价比无线网络一体化解决方案等痛点，柠檬网联“x计划”作为公司10周年推出的高性价比、可信赖的无线网络建设和运营整体方案，项目模式直击职教网络市场痛点，现将方案开放给全国合作伙伴，由柠檬网联提供一站式全程项目托管服务，确保项目建设落地，让您省心省力省事。
        </div>

      </div>
    </div>
    <div class="step">
      <div class="title wow animate__animated durationTime animate__fadeInUp">“X计划”全程托管，让您轻松做甩手掌柜</div>
      <div class="secondTitle wow animate__animated durationTime animate__fadeInUp">
        x计划拥有一整套专业执行标准和执行能力，拥有从项目勘察到用户服务全流程的SOP标准流程，实现无线网络硬件、软件、平台一体化解决方案快速实施落地，项目实
        行全程托管服务，排除项目风险，保障项目低投入高回报，让您轻松做甩手掌柜，躺着也能赚钱。
      </div>
      <div class="item">
        <div class="one wow animate__animated  animate__fadeInLeft">项目勘察</div>
        <div class="other wow animate__animated  animate__fadeInLeft">用户调研</div>
        <div class="other wow animate__animated  animate__fadeInLeft">方案设计</div>
        <div class="other wow animate__animated  animate__fadeInLeft">项目评估</div>
        <div class="other wow animate__animated  animate__fadeInLeft">实施上线</div>
        <div class="other wow animate__animated  animate__fadeInLeft">推广运营</div>
        <div class="other wow animate__animated  animate__fadeInLeft">设备维护</div>
        <div class="other wow animate__animated  animate__fadeInLeft">用户服务</div>
      </div>
    </div>
    <div class="choose">
      <div class="title secondTitle wow animate__animated durationTime animate__fadeInUp">为什么选择投资柠檬网联“x计划”</div>
      <div style="text-align: center;position: relative" class="secondTitle wow animate__animated durationTime animate__fadeInUp">
        <div class="item wow animate__animated durationTime animate__bounceInLeft" style="left: 38.5%;top: 7%;">
          <div class="title" style="color: #FEF100">专业</div>
          <div class="desc">垂直职教校园场景10年，已成为行业解决方案专家</div>
        </div>
        <div class="item wow animate__animated durationTime animate__bounceInLeft" style="left: 63%;top: 27%;">
          <div class="title" style="color: #DBE002">靠谱</div>
          <div class="desc">已成功验证几百个项目，经验丰富，成熟靠谱</div>
        </div>
        <div class="item wow animate__animated durationTime animate__bounceInLeft" style="left: 62%;top: 53%;">
          <div class="title" style="color: #29B2C8">赚钱</div>
          <div class="desc">一次投入，一年回本，五年投资回报率400%</div>
        </div>
        <div class="item wow animate__animated durationTime animate__bounceInLeft" style="    left: 39.5%;bottom: 11%;">
          <div class="title" style="color: #347DEA">放心</div>
          <div class="desc">每笔订单实时分账，每笔订单随时查看，放心</div>
        </div>
        <div class="item wow animate__animated durationTime animate__bounceInLeft" style="left: 12%;top: 53%;">
          <div class="title" style="color: #98BF55">省事</div>
          <div class="desc">勘、设、建、运、维、服，总部全程托管，省时省力</div>
        </div>
        <div class="item wow animate__animated durationTime animate__bounceInLeft" style="left: 12%;top: 27%;">
          <div class="title" style="color:#FF4100">省心</div>
          <div class="desc">7*24小时云运维和客户服务，随时在线，无后顾之忧</div>
        </div>
        <img src="../../assets/image/xplan/choose.png" style="width: 11.5rem">
      </div>
    </div>
    <div class="mode">
      <div class="title wow animate__animated durationTime animate__fadeInUp">三种合作模式可选，支持合作伙伴先收益后选择投资模式</div>
      <div class="secondTitle secondTitle wow animate__animated durationTime animate__fadeInUp">柠檬网联提供三种投资模式，您可以选择适合您的合作方式，为您带来更高的收益与保障。</div>
      <div class="data secondTitle wow animate__animated durationTime animate__fadeInUp">
        <div class="lf">
          <div class="row1"></div>
          <div style="border-top-left-radius: 0.1rem;  color: #333333 !important;" class="row2 con">投资模式</div>
          <div class="row3 con">网联主投</div>
          <div class="row4 con">共投共建</div>
          <div class="row5 con">合作伙伴主投</div>
        </div>
        <div class="mid">
          <div class="row1 he" style="border-top-left-radius: 0.1rem">投资方式</div>
          <div class="row2 con">
            <span>合作伙伴</span>
            <span>网联</span>
          </div>
          <div class="row3 con">
            <div>0投资</div>
            <div>
              <div>一次性投资</div>
              <div>宽带、云平台</div>
            </div>
          </div>
          <div class="row4 con">
            <div>施工</div>
            <div>
              <div>宽带、设备、云平台</div>
            </div>
          </div>
          <div class="row5 con">
            <span>一次性投资</span>
            <span>云平台</span>
          </div>
        </div>
        <div class="rg mid">
          <div class="row1 he">分工安排</div>
          <div class="row2 con">
            <span>合作伙伴</span>
            <span>网联</span>
          </div>
          <div class="row3 con">
            <div>
              <div>项目签约</div>
            </div>
            <div>

              <div>全程负责执行</div>
            </div>
          </div>
          <div class="row4 con">
            <div>项目签约+施工执行+现场维护</div>
            <div>
              <div>宽带接入、推广运营、</div>
              <div>云维护、客服</div>
            </div>
          </div>
          <div class="row5 con">
            <span>项目签约</span>
            <span>全程落地执行及指导支持</span>
          </div>
        </div>
        <div class="last mid">
          <div class="row1 he" style="border-top-right-radius: 0.1rem">收入分成</div>
          <div class="row2 con">
            <span>合作伙伴</span>
            <span>网联</span>
          </div>
          <div class="row3 con">
            <div>20%</div>
            <div>
             80%
            </div>
          </div>
          <div class="row4 con">
            <div>40%</div>
            <div>
            60%
            </div>
          </div>
          <div class="row5 con">
            <div>80%～90%</div>
            <div>
              <div>10～20%</div>
              <div>(平台10%+运维客服10%)</div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <trusteeship />-->
<!--    <privilege-analysis />-->
    <div class="money" style="display: none">
      <img class="money-first wow animate__animated durationTime animate__fadeInUp" src="../../assets/image/xplan/money-first.png">
      <div>
        <img style="width: 3.97rem" class=" wow animate__animated durationTime animate__fadeInUp" src="../../assets/image/xplan/money1.png">
        <img style="width: 4.29rem" class=" wow animate__animated durationTime animate__fadeInUp" src="../../assets/image/xplan/money-three.png">
        <img style="width: 3.97rem" class=" wow animate__animated durationTime animate__fadeInUp" src="../../assets/image/xplan/money2.png">
      </div>

      <div class="money-con">
        <div class="money-con-first wow animate__animated durationTime animate__fadeInUp">
          为您全程提供安全保障，三种投资模式任您选择：
        </div>
        <div class="money-con-btn">
         <div class="money-con-btn-item wow animate__animated durationTime animate__fadeInUp">1.支持您全额投资享受项目高收益</div>
          <div class="money-con-btn-item wow animate__animated durationTime animate__fadeInUp">2.邀您与网联共建项目，共享项目的长期收益</div>
          <div class="money-con-btn-item wow animate__animated durationTime animate__fadeInUp">3.为您提供垫资服务，快速启动项目</div>
        </div>
      </div>
    </div>
    <div class="cases">
      <div style="display:flex;justify-content: center">
        <div class="titleSub">Collaboration Cases</div>
        <div class="title wow animate__animated durationTime animate__fadeInUp">
          合作案例
        </div>
      </div>
      <div class="case-item">
        <div style="cursor: pointer" @click="detailPartner(3)" class="item wow animate__animated durationTime animate__fadeInUp showDetail">
          <div class="label">
            广东某科技中职学校
          </div>
          <div>
            1.项目建设成本仅需友商的四分之 一;2.项目9个月回本,12个月投
            资回报率133%;
          </div>
          <img src="../../assets/image/xplan/case1.png" />
        </div>
        <div style="cursor: pointer" @click="detailPartner(1)" class="item wow animate__animated durationTime animate__fadeInUp showDetail">
          <div class="label">
            广西某技师学校
          </div>
          <div>
            1.万人规模职校,高并发场景,用网体验有保障;2.校园网络全覆盖,
            设备需求多,回本周期仅为10.3个月
          </div>
          <img src="../../assets/image/xplan/case2.png" />
        </div>
        <div
          @click="detailPartner(2)"
          style="margin-top: 1.44rem ;cursor: pointer"
          class="item wow animate__animated durationTime animate__fadeInUp showDetail"
        >
          <div class="label">
            江西某技工学校
          </div>
          <div class="desc">
            1、防共享、多种认证方式、线上 购买WiFi套餐等功能支持，杜绝
            WiFi分享，降低用户使用门槛； 2、地推码、优惠券、福利中心、
            自动续费等运营推广支持，提高用 户使用率
          </div>
          <img src="../../assets/image/xplan/case3.png" />
        </div>
        <div
          style="margin-top: 1.44rem;cursor: pointer"
           @click="detailPartner(3)"
          class="item wow animate__animated durationTime animate__fadeInUp showDetail"
        >
          <div class="label">
            厦门某技术学校
          </div>
          <div class="desc">
            1、学校对学生用网时间段有特别要 求，并对学生访问网站有所限定，
            设定安全敏感词监测，如若学生搜 索相关词汇，将进行预警提醒，以
            辅助学校对学生的安全管理和引导。
          </div>
          <img src="../../assets/image/xplan/case4.png" />
        </div>
      </div>
    </div>
    <div class="vip">
      <div class="title wow animate__animated durationTime animate__fadeInUp">现加入“X计划”前<span class="main-color">10</span>首个项目</div>
      <div class="plus">
        <div class="item wow animate__animated durationTime animate__bounceInLeft" style="text-align: center">
          <img src="../../assets/image/xplan/plus-icon1.png">
          <div class="desc" >
            <div class="intro">采用柠檬网联全套设备，享受折上折，</div>
            <div class="intro">渠道价基础上再打8.8折，X计划<span class="main-color">Plus尊享价</span>。</div>
          </div>
        </div>
        <div class="item wow animate__animated durationTime animate__bounceInLeft" style="text-align: center">
          <img src="../../assets/image/xplan/plus-icon2.png">
          <div class="desc" >
            <div class="intro">运维客服服务费合约期内全免，</div>
            <div class="intro"><span class="main-color">只收10%</span>平台费</div>
          </div>
        </div>
        <div class="item wow animate__animated durationTime animate__bounceInLeft" style="text-align: center">
          <img src="../../assets/image/xplan/plus-icon3.png">
          <div class="desc" >
            <div class="intro">一次性设备投资回收周期<span class="main-color">保障12个月</span>，</div>
            <div class="intro">如12个月内未收回，平台给予差额补贴。</div>
          </div>
        </div>
        <div class="item wow animate__animated durationTime animate__bounceInLeft" style="text-align: center;">
          <img src="../../assets/image/xplan/plus-icon4.png">
          <div class="desc" >
            <div class="intro">如遇不可抗力等因素项目无法继续执行，</div>
            <div class="intro"> 承诺设备回收，按照月折旧<span class="main-color">2%</span>进行回收。</div>
          </div>
        </div>
        <div class="item wow animate__animated durationTime animate__bounceInLeft" style="text-align: center;">
          <img src="../../assets/image/xplan/plus-icon5.png">
          <div class="desc" >
            <div class="intro">合作伙伴如有需求，</div>
            <div class="intro"> 可提供可信赖的第三方进行<span class="main-color">配资支持。</span></div>
          </div>
        </div>
        <div class="item wow animate__animated durationTime animate__bounceInLeft" style="text-align: center;">
          <img src="../../assets/image/xplan/plus-icon6.png">
          <div class="desc" >
            <div class="intro">前10个伙伴增加PLUS特权—先看收益再投资，</div>
            <div class="intro">可由柠檬网联先行<span class="main-color">全部垫资建设</span>。</div>
          </div>
        </div>
      </div>
      <div class="title wow animate__animated durationTime animate__fadeInUp">现加入“X计划”前<span class="main-color">100</span>首个项目</div>
      <div class="plus2">
        <div class="line1">
          <div class="item wow animate__animated durationTime animate__bounceInLeft" style="text-align: center">
            <img src="../../assets/image/xplan/plus-icon7.png">
            <div class="desc" >
              <div class="intro">采用柠檬网联全套设备，
              </div>
              <div class="intro">享受年度千万补贴，<span class="main-color">7～8折渠道价</span></div>
            </div>
          </div>
          <div class="item wow animate__animated durationTime animate__bounceInLeft" style="text-align: center">
            <img src="../../assets/image/xplan/plus-icon8.png">
            <div class="desc" >
              <div class="intro">免2年运维客服服务费，
              </div>
              <div class="intro">前2年只收<span class="main-color">10%平台费</span></div>
            </div>
          </div>
          <div class="item wow animate__animated durationTime animate__bounceInLeft" style="text-align: center">
            <img src="../../assets/image/xplan/plus-icon9.png">
            <div class="desc" >
              <div class="intro">一次性设备投资回收周期<span class="main-color">保障15个月</span>，
              </div>
              <div class="intro">如15个月内未收回，平台给予差额补贴。</div>
            </div>
          </div>
        </div>
        <div class="line2" style="padding: 0px 3.5rem 0 2rem;margin-top: 0.24rem">
          <div class="item wow animate__animated durationTime animate__bounceInLeft" style="text-align: center">
            <img src="../../assets/image/xplan/plus-icon10.png">
            <div class="desc" >
              <div class="intro">如遇不可抗力等因素，

              </div>
              <div class="intro"> 承诺设备回收，按照月折旧<span class="main-color">3%</span>进行回收</div>
            </div>
          </div>
          <div class="item wow animate__animated durationTime animate__bounceInLeft" style="text-align: center">
            <img src="../../assets/image/xplan/plus-icon11.png">
            <div class="desc" >
              <div class="intro">如有项目资金需求，

              </div>
              <div class="intro"> 可提供<span class="main-color">第三方配资</span>支持</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <feedback />


  </div>
</template>

<script>
import countTo from "vue-count-to";
import { WOW } from "wowjs";
import trusteeship from "./components/trusteeship";
import privilegeAnalysis from "./components/privilegeAnalysis";
import feedback from "./components/feedback";

export default {
  name: "xplan",
  components: {
    countTo,
    trusteeship,
    privilegeAnalysis,
    feedback
  },
  data() {
    return {
      count4Counted: false
    };
  },
  created() {


  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    // init wow
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true //异步加载的内容是否有效
    });
    wow.init();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const counts = [this.$refs.count4];
      counts.forEach(item => {
        const top = item.$el.getBoundingClientRect().top;
        if (top < window.innerHeight) {
          if (!this[`${item.$vnode.data.ref}Counted`]) {
            item.start();
            this[`${item.$vnode.data.ref}Counted`] = true;
          }
        }
      });
    },
    detailPartner(id){
      this.$router.push({
        name: "xPartner",
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style scoped>
.first {
  width: 100%;
  height: 100vh;
  background: url("../../assets/image/xplan/first.png") center no-repeat;
  background-size: cover;
}

.x-desc {
  width: 100%;
  height: 7.2rem;
  background: url("../../assets/image/xplan/x-desc.png") center no-repeat;
  background-size: cover;
  padding-left: 2.18rem;
}
</style>

<style scoped lang="scss">
.choose{
  background: url('../../assets/image/xplan/choose-bg.png') center
  no-repeat;
  background-size: cover;
  padding: 1rem 0;
  .title{
    font-weight: 500;
    font-size: 0.53rem;
    color: #FFFFFF;
    margin-bottom: 1.16rem;
    text-align: center;
  }
  .item{
    position: absolute;
    text-align: center;
    .title{
      font-weight: 500;
      font-size: 0.34rem;
      margin-bottom: 0.2rem;
    }
    .desc{
      font-weight: 400;
      font-size: 0.2rem;
      color: #FFFFFF;
    }
  }
}
.step{
  background: url('../../assets/image/xplan/step-bg.jpg') center
  no-repeat;
  background-size: cover;
  background-color: #510203;
  padding: 1.82rem 2.18rem 2.08rem 2.18rem;
  .title{
    font-weight: 500;
    font-size: 0.53rem;
    color: #FFFFFF;
  }
  .secondTitle{
    font-weight: 400;
    font-size: 0.2rem;
    color: #FFFFFF;
    line-height: 0.5rem;
    margin-top: 0.4rem;
  }
  .item{
    display: flex;
    margin-top: 0.4rem;
    .one{
      background: url('../../assets/image/xplan/step-icon.png') center
      no-repeat;
      background-size: cover;
      width: 1.98rem;
      font-size: 0.2rem;
      color: #333333;
      font-weight: 500;
      text-align: center;
      padding: 0.23rem 0;
    }
    .other{
      background: url('../../assets/image/xplan/step-icon1.png') center
      no-repeat;
      background-size: cover;
      width: 1.98rem;
      font-size: 0.2rem;
      color: #333333;
      font-weight: 500;
      text-align: center;
      padding: 0.23rem 0;
      margin-left: -0.18rem;
    }
  }
}
.x-about{
  background: url('../../assets/image/xplan/x-desc.png') center no-repeat;
  background-size: cover;
  background-color: #510203;
  padding: 0 2.18rem  0 2.18rem;
  display: flex;
  position: relative;
  .left{
    width: 50%;
    border-right:1px solid #FFFFFF;;
    .title {
      font-size: 0.38rem;
      font-weight: 500;
      text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      margin-top: 2.5rem;
      position: relative;
      color: #fff;
      display: inline-block;
    }

    .titleSub {
      position: absolute;
      margin-top: 2.25rem;
      font-size: 0.38rem;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.51);
      text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      letter-spacing: 0.02rem;
    }
    .desc{
      font-weight: 400;
      font-size: 0.18rem;
      color: #FFFFFF;
      line-height: 0.4rem;
      width: 5.95rem;
      padding-bottom: 2rem;
      margin-top: 0.4rem;
    }
  }
  .right{
    width: 50%;
    .desc{
      font-weight: 400;
      font-size: 0.18rem;
      color: #FFFFFF;
      line-height: 0.5rem;
      text-indent: 2em;
      margin-top: 2.62rem;
      padding-left: 1.2rem;
    }
  }
}
.mode{
  background: url("../../assets/image/xplan/analysisBg1.png") center no-repeat;
  background-size: cover;
  background-color: #510203;
  padding: 1rem 2.18rem;
  .title{
    font-weight: 500;
    font-size: 0.53rem;
    color: #FFFFFF;
    text-align: center;
  }
  .secondTitle{
    font-weight: 400;
    font-size: 0.24rem;
    color: #FFFFFF;
    text-align: center;
    margin-top: 0.2rem;
    margin-bottom: 0.4rem;
  }
  .data{
    .he{
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      font-size: 0.23rem;
      color: #AD1515;
      border-right: 0.01rem  solid #FFFFFF;
      background: linear-gradient(180deg , #E3C99F 0%, #FFFDE5 100%);
    }
    display: flex;
    .row1{
      height: 0.7152rem;
    }
    .row2{
      height: 0.72rem;
      font-size: 0.21rem !important;
      color: #EDDCB9 !important;
    }
    .row3{
      height: 0.96rem;
    }
    .row4{
      height: 0.96rem;
    }
    .row5{
      height: 0.95rem;
    }
    .rg{
      width: 5.48rem !important;
    }
    .last{
      width: 4.56rem !important;
    }
    .mid{
      background: #440203;
      width: 3.5rem;
      .con{
        font-weight: 400;
        color: #FFFFFF;
        font-size: 0.19rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0.2rem 0 0.2rem;
        border-bottom: 0.01rem solid #FFFFFF;
        border-right: 0.01rem  solid #FFFFFF;
      }
    }
    .lf{
      width: 1.7rem;
     .con{
       background: linear-gradient( 180deg, #E3C99F 0%, #FFFDE5 100%);
       border-bottom: 0.01rem  solid #FFFFFF;
       display: flex;
       align-items: center;
       padding-left: 0.22rem;
       font-weight: 500;
       font-size: 0.21rem;
       color: #333333;
     }
    }
  }
}
.vip{
  .plus2{
    margin-top: 0.8rem;
    margin-bottom: 0.8rem;
    background: url("../../assets/image/xplan/vip-bg1.png") center no-repeat;
    background-size: cover;
    height: 7.98rem;
    padding: 2.32rem 0.2rem 0.4rem 0.1rem;
    font-weight: 500;
    font-size: 0.24rem;
    color: #FFFFFF;
    line-height: 0.39rem;
    .line1{
      display: flex;
      justify-content: space-around;
      .item{
        width: 33.333%;
        img{
          width: 1.5rem;
        }
        .desc{
          .intro{
            white-space: nowrap;
          }
        }
      }
    }
    .line2{
      display: flex;
      justify-content: space-around;
      .item{
        //width: 33.333%;
        img{
          width: 1.5rem;
        }
        .desc{
          .intro{
            white-space: nowrap;
          }
        }
      }
    }
  }
  background-color: #510203;
  padding:1rem 2.18rem ;
  .title{
    font-weight: 500;
    font-size: 0.53rem;
    color: #FFFFFF;
    text-align: center;
  }
  .plus{
    margin-top: 1rem;
    margin-bottom: 0.8rem;
    background: url("../../assets/image/xplan/vip-bg2.png") center no-repeat;
    background-size: cover;
    height: 7.98rem;
    padding: 2.32rem 0.2rem 0.4rem 0.1rem;
    font-weight: 500;
    font-size: 0.24rem;
    color: #FFFFFF;
    line-height: 0.39rem;
    display: flex;
    justify-content: space-between;

    flex-wrap: wrap;
    .item{
      width: 33.333%;
      img{
        width: 1.5rem;
      }
      .desc{
        .intro{
          white-space: nowrap;
        }
      }
    }
  }
}

.x-desc {
  .title {
    font-size: 0.38rem;
    font-weight: 500;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    margin-top: 1.96rem;
    position: relative;
    color: #fff;
    display: inline-block;
  }

  .titleSub {
    position: absolute;
    margin-top: 1.71rem;
    font-size: 0.38rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.51);
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    letter-spacing: 0.02rem;
  }

  .slogan {
    margin-top: 0.6rem;
    display: flex;
    justify-content: start;
    align-items: baseline;
    font-size: 0.45rem;
    font-weight: 600;

    .one {
      color: white;
    }

    .two {
      color: #fef100;
      font-size: 0.6rem;
      margin-left: 0.2rem;
    }
  }
  .desc-one {
    font-size: 0.18rem;
    color: #ffffff;
    font-weight: 400;
    margin-top: 0.35rem;
  }
  .desc-two {
    font-size: 0.18rem;
    color: #ffffff;
    font-weight: 400;
    margin-top: 0.3rem;
    width: 8.82rem;
    line-height: 0.3rem;
  }
}
.cases {
  width: 100%;
  background: url("../../assets/image/xplan/x-cases.png") center no-repeat;
  background-size: cover;
  padding: 1rem 2.18rem;
  height: 21.81rem;
  .title {
    font-size: 0.38rem;
    font-weight: 500;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    position: relative;
    margin-top: 0.22rem;
    color: #fff;
    display: inline-block;
  }

  .titleSub {
    position: absolute;
    font-size: 0.38rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.51);
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    letter-spacing: 0.02rem;
  }
  .case-item {
    margin-top: 1.49rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .showDetail{
      &:hover{
        .label{
          background: #FEF100;
        }
      }

    }
    .item {
      position: relative;
      width: calc((100% - 0.8rem) / 2);
      background-color: #5f2b28;
      color: #ffffff;
      font-weight: 400;
      font-size: 0.38rem;
      line-height: 0.6rem;
      padding: 1.1rem 0.4rem 0.4rem 0.4rem;
      border-radius: 0.2rem;
      border: 1px solid #e8c6a5;
      img {
        margin-top: 0.2rem;
        width: 100%;
      }
      .desc {
        height: 3.53rem;
      }
      .label {
        font-weight: 500;
        font-size: 0.48rem;
        color: #4d1e0e;
        background: linear-gradient(90deg, #efd0af 0%, #e1bb99 100%);
        border-radius: 0.28rem;
        border: 0.01rem solid #707070;
        padding: 0.38rem 0.54rem;
        position: absolute;
        min-width: 5.78rem;
        text-align: center;
        left: 50%;
        top: 0;
        transform: translate(-50%, -50%);
      }
    }
  }
}
.money {
  width: 100%;
  //height: 10.8rem;
  background: url("../../assets/image/xplan/money.png") center no-repeat;
  background-size: cover;
  background-color: #510203;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 1.43rem;
  .money-first{
    width: 11.55rem;
    margin-top: 0.97rem;
  }
  .money-second{
    width: 9.01rem;
    margin-top: 0.83rem;
  }
  .money-con{
    width: 14.84rem;
    background: linear-gradient( 180deg, #F9E0DC 0%, #FFFEFE 100%);
    border-radius: 20px;
    padding: 0.4rem 0.4rem;
    margin-top: 0.8rem;
    .money-con-first{
      font-weight: 500;
      font-size: 0.5rem;
      color: #333333;
      text-align: center;
    }
    .money-con-btn{
      display: flex;
      justify-content: space-between;
      margin-top: 0.4rem;
      .money-con-btn-item{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 4.54rem;
        height: 0.89rem;
        background: #B0241B;
        border-radius: 0.45rem;
        font-weight: 400;
        font-size: 0.2rem;
        color: #FFFFFF;
      }
    }
  }
}

@media (max-width: 1199px) {
  .first{
    height: 10.8rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/xplan/index.vue